import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FundDDQRun } from '@core/models/fund-ddq-run.model';
import { PaginationParams } from '@core/api/api-entity.service';

export interface FundDDQRunState {
  fundDDQRuns: FundDDQRun[];
  loading: boolean;
  error: string | null;
  pagination: PaginationParams | null;
}

function createInitialState(): FundDDQRunState {
  return {
    fundDDQRuns: [],
    loading: false,
    error: null,
    pagination: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'fundDDQRuns', resettable: true })
export class FundDDQRunStore extends Store<FundDDQRunState> {
  constructor() {
    super(createInitialState());
  }

  setFundDDQRuns(runs: FundDDQRun[], pagination?: PaginationParams | null): void {
    this.update({
      fundDDQRuns: runs,
      loading: false,
      error: null,
      pagination: pagination || null,
    });
  }

  addFundDDQRun(run: FundDDQRun): void {
    const currentState = this.getValue();
    this.update({
      fundDDQRuns: [...currentState.fundDDQRuns, run],
    });
  }

  updateFundDDQRun(run: FundDDQRun): void {
    const currentState = this.getValue();
    const updatedRuns = currentState.fundDDQRuns.map((r) => (r.productUid === run.productUid ? run : r));
    this.update({
      fundDDQRuns: updatedRuns,
    });
  }

  removeFundDDQRun(productUid: string): void {
    const currentState = this.getValue();
    const updatedRuns = currentState.fundDDQRuns.filter((r) => r.productUid !== productUid);
    this.update({
      fundDDQRuns: updatedRuns,
    });
  }

  setLoading(loading: boolean): void {
    this.update({
      loading,
    });
  }

  setErrorState(error: string | null): void {
    this.update({
      error,
      loading: false,
    });
  }
}
